module.exports = __webpack_public_path__ + "static/media/gp.622093f8.jpg";